import { render } from "./ThemesPanel.vue?vue&type=template&id=766913f2&scoped=true&ts=true"
import script from "./ThemesPanel.vue?vue&type=script&lang=ts"
export * from "./ThemesPanel.vue?vue&type=script&lang=ts"

import "./ThemesPanel.vue?vue&type=style&index=0&id=766913f2&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766913f2"]])

export default __exports__